import React from 'react';

import './PlusFlair.scss';

interface PlusFlairProps {
  isPlus?: boolean;
  children: React.ReactNode;
}

/**
 * The Jookable+ flair: a coral ring round a member's profile picture and a small "+" at
 * its corner. Wraps whatever avatar a screen already draws, picture or initials, and
 * scales with it, so the phone rows and the TV get the same mark. Non-members' avatars
 * come back untouched.
 */
const PlusFlair = ({ isPlus, children }: PlusFlairProps) => {
  if (!isPlus) {
    return <>{children}</>;
  }
  return (
    <span className="plus-flair" title="Jookable+ member">
      {children}
      <svg className="plus-flair-badge" viewBox="0 0 10 10" aria-label="Jookable+ member" role="img">
        <circle cx="5" cy="5" r="5" />
        <path d="M5 2.4v5.2M2.4 5h5.2" />
      </svg>
    </span>
  );
};

export default PlusFlair;
